import { SystemChecksheetAssignmentProjection } from '@completion/models';
import { SystemAction, SystemActionTypes } from '@completion/actions';

export const initialState: SystemState = {
  systemScopeOfWork: [],
};

export interface SystemState {
  systemScopeOfWork: SystemChecksheetAssignmentProjection[];
}

export function systemReducer(state: SystemState = initialState, action: SystemAction): SystemState {
  switch (action.type) {
    case SystemActionTypes.LoadSystemScopeOfWorkSuccess:
      return {
        ...state,
        systemScopeOfWork: action.scopeOfWork,
      };

    default:
      return state;
  }
}
